import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OhayoLocaleModule } from '@ohayojp/theme';
import { OhayoUtilModule } from '@ohayojp/util';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { G2MiniProgressComponent } from './mini-progress.component';

const COMPONENTS = [G2MiniProgressComponent];

@NgModule({
  imports: [CommonModule, OhayoUtilModule, OhayoLocaleModule, NzToolTipModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class G2MiniProgressModule { }
